function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
export default function withRender(WrappedComponent) {
  var Enhance = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(Enhance, _React$Component);
    function Enhance() {
      return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Enhance.prototype;
    _proto.render = function render() {
      var renderFn = function renderFn() {
        return null;
      };
      if (this.props.children) {
        renderFn = this.props.children;
      }
      if (this.props.render) {
        renderFn = this.props.render;
      }
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
        render: renderFn
      }));
    };
    return Enhance;
  }(React.Component);
  Enhance.propTypes = process.env.NODE_ENV !== "production" ? {
    children: function children(props, propName, componentName) {
      if (!props.render && (props[propName] === undefined || typeof props[propName] !== 'function')) {
        return new Error(componentName + ": Please provide a either a render prop or a function as a child!");
      }
    },
    render: function render(props, propName, componentName) {
      if (!props.children && (props[propName] === undefined || typeof props[propName] !== 'function')) {
        return new Error(componentName + ": Please provide a either a render prop or a function as a child!");
      }
    }
  } : {};
  hoistNonReactStatic(Enhance, WrappedComponent);
  return Enhance;
}